import { Injectable } from "@angular/core";

export interface OpenItemsCsvRow {
  bqStep: string;
  financialCommunity: string;
  lotBlock: string;
  lotAddress: string;
  constructionManager: string;
  dateOfInspection: string;
  dueDate: string;
  assignedTo: string;
  area: string;
  component: string;
  description: string;
}

@Injectable({ providedIn: "root" })
export class OpenItemsCsvService {

  public downloadOpenItemsCsv(
    lotBlock: string,
    openItemsCsvRows: OpenItemsCsvRow[],
  ): void {
    const headers = [
      "BQ Step",
      "Financial Community",
      "LotBlock",
      "Address",
      "Construction Manager",
      "Date of Inspection",
      "Due Date",
      "Assigned To",
      "Area",
      "Component",
      "Description",
    ];

    const csvContent = [
      headers.join(","),
      ...openItemsCsvRows.map(row => {
        const rowData = [
          row.bqStep,
          row.financialCommunity,
          row.lotBlock,
          row.lotAddress,
          row.constructionManager,
          row.dateOfInspection,
          row.dueDate,
          row.assignedTo,
          row.area,
          row.component,
          row.description
        ];

        return rowData
          .map(cell => this.escapeCsvCell(cell))
          .join(",");
      }),
    ].join("\n");

    const fileName = `OpenItems_${lotBlock}_${new Date().toISOString()
.split("T")[0]}.csv`;
    this.triggerBrowserDownload(csvContent, fileName);
  }

  /**
   * Escapes a string for CSV format to handle commas, newlines, and double-quotes.
   */
  private escapeCsvCell(cell: string): string {
    if (!cell) {
      return "";
    }

    const stringCell = String(cell);

    if (
      stringCell.includes(",") ||
      stringCell.includes("\"") ||
      stringCell.includes("\n") ||
      stringCell.includes("\r")
    ) {
      return `"${stringCell.replace(/"/g, "\"\"")}"`;
    }
    return stringCell;
  }

  /**
   * Creates a Blob and uses an invisible anchor tag to trigger a file download.
   */
  private triggerBrowserDownload(csvContent: string, fileName: string): void {
    const bom = new Uint8Array([0xef, 0xbb, 0xbf]); // UTF-8 BOM for Excel
    const blob = new Blob([bom, csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.setAttribute("href", url);
    link.setAttribute("download", fileName);
    link.style.visibility = "hidden";

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}
